import { CollectionData } from "./collections";
import { getCollectionImageUrl } from "@/lib/cloudinary";

export const shadesOfGreyDescriptionParagraphs = [
  "Shades of Grey célèbre l'art des nuances et des contrastes à travers une collection aux textures riches et aux silhouettes contemporaines. Chaque création joue avec la lumière et l'ombre, créant une symphonie visuelle entre force et délicatesse.",
  "Les matières nobles se parent de motifs graphiques sophistiqués, tandis que la palette de gris s'étend du blanc lumineux aux tonalités les plus profondes. Cette collection propose une garde-robe versatile où l'élégance casual côtoie le raffinement des tenues de soirée.",
  "Une ode à la femme moderne qui embrasse toutes ses facettes, de l'allure décontractée au glamour assumé. Shades of Grey réinvente les codes du luxe contemporain en célébrant la liberté d'expression à travers une mode intemporelle et audacieuse.",
];

export const shadesOfGreyCollection: CollectionData = {
  id: "2024-shades-of-grey",
  title: "Shades of Grey",
  descriptionParagraphs: shadesOfGreyDescriptionParagraphs,
  images: [
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-01"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-02"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-03"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-04"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-05"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-06"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-07"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-08"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-09"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-10"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-11"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-12"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-13"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-14"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-15"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-16"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-17"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-18"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-19"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-20"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-21"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-22"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-23"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-24"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-25"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-26"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-27"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-28"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-29"),
    getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-30"),
  ],
  date: "09/24",
  bannerImage: getCollectionImageUrl("2024-shades-of-grey", "ALEXANDRA-GREY-SHADES-OF-GREY-01"),
};
